import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { ManCodeId } from '#api/tmsApiService'
import type { RecentManCodesData_0_2_0 } from '#features/UserData/UserData_0_2_0'

export type RecentManCodes = RecentManCodesData_0_2_0['manCodes']
export type RecentManCodeEntry = RecentManCodes[number]

export type RecentManCodesState = {
  manCodes: RecentManCodes
}

const initialRecentManCodesState: RecentManCodesState = { manCodes: [] }

export const recentManCodesSlice = createSlice({
  name: 'recent-man-codes',
  initialState: initialRecentManCodesState,
  reducers: {
    _trackManCode: (
      state,
      {
        payload: { manCode, partPeriod, deliveryDate, marketDenomination, title },
      }: PayloadAction<Omit<RecentManCodesState['manCodes'][number], 'createdAt' | 'lastUsedAt' | 'timestamp'>>,
    ) => {
      // filtering out invalid man codes, which has happened in the past by updating the data storage
      state.manCodes = state.manCodes.filter((x) => x.manCode !== undefined)
      const existingIndex = state.manCodes.findIndex((x) => x.manCode === manCode)
      if (existingIndex === -1) {
        state.manCodes.unshift({ manCode: manCode, partPeriod: partPeriod, deliveryDate, createdAt: Date.now(), marketDenomination, title })
        return
      }
      const entry = state.manCodes[existingIndex]
      state.manCodes[existingIndex] = {
        createdAt: entry.timestamp ?? entry.createdAt ?? Date.now(),
        ...entry,
        partPeriod,
        deliveryDate,
        marketDenomination,
        title,
        lastUsedAt: Date.now(),
      }
    },
    removeManCode: (state, { payload }: PayloadAction<ManCodeId | undefined>) => {
      // filtering out invalid man codes, which has happened in the past by updating the data storage
      state.manCodes = state.manCodes.filter((x) => x.manCode !== undefined)
      const existingIndex = state.manCodes.findIndex((x) => x.manCode === payload)
      if (existingIndex !== -1) {
        state.manCodes.splice(existingIndex, 1)
      }
    },
  },
})
